import React, { ReactElement } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

import { Policy } from "../../../store/pomeriumApi";

type Props = {
  onDelete(): void;
  selectedPolicies: Policy[];
};

const ActionToolbar = ({ onDelete, selectedPolicies }: Props): ReactElement => {
  function handleClickDelete(evt: React.MouseEvent) {
    evt.preventDefault();
    onDelete();
  }

  const assignedPolicies =
    selectedPolicies?.filter((p) => {
      return p.routes?.length > 0;
    }) || [];

  if (selectedPolicies.length) {
    return (
      <>
        <Grid>
          <Tooltip
            title={
              assignedPolicies.length
                ? "One or more optional policies are currently assigned to a route and so they cannot be deleted."
                : "Delete"
            }
          >
            <span>
              <Button
                aria-label="delete"
                color="primary"
                size="small"
                startIcon={<DeleteIcon />}
                onClick={handleClickDelete}
                disabled={!!assignedPolicies.length}
              >
                Delete
              </Button>
            </span>
          </Tooltip>
        </Grid>
      </>
    );
  }

  return <></>;
};
export default ActionToolbar;
